module.exports = __webpack_public_path__ + "d932c60652acf60924987457c32a3c44.mp3";